// Data-driven per-tenant white-label config, keyed by hostname.
// To add a new branded portal later, add ONE entry below — no code changes.

const TENANTS = {
  "portal.ashlanclinic.com": {
    key: "ashlan",
    whiteLabel: true,
    orgNameMatchers: ["ashlan"],
    portalName: "Ashlan Clinic",
    shortName: "Ashlan Clinic",
    tagline: "Marketing Portal",
    title: "Ashlan Clinic — Marketing Portal",
    logoUrl: "/logo-ashlan.png",
    colors: { teal: "#5FA8B4", deepTeal: "#3A7A8C", charcoal: "#3C4048" },
  },
};

export const DEFAULT_TENANT = {
  key: "default",
  whiteLabel: false,
  orgNameMatchers: null,
  portalName: "Post Your Content",
  shortName: "Post Your Content",
  tagline: "Content Manager",
  title: "Post Your Content",
  logoUrl: "/logo.png",
  colors: { teal: "#5FA8B4", deepTeal: "#3A7A8C", charcoal: "#3C4048" },
};

// Effective host resolution. Supports a `?__host=` test seam so the branded
// experience can be exercised on the preview URL before the real domain is bound.
export function getEffectiveHost() {
  try {
    if (process.env.NODE_ENV !== "production") {
      const params = new URLSearchParams(window.location.search);
      const override = params.get("__host");
      if (override) sessionStorage.setItem("__tenant_host", override);
      const stored = sessionStorage.getItem("__tenant_host");
      if (stored) return stored;
    }
    return window.location.hostname;
  } catch {
    return typeof window !== "undefined" ? window.location.hostname : "";
  }
}

export function getTenant() {
  return TENANTS[getEffectiveHost()] || DEFAULT_TENANT;
}

// True if an organization name belongs to the tenant scoped to this domain.
// Matches on exact name or a whole-word match (so "Acme Clinic" matches
// "acme" but "Acmeland Corp" does not).
export function orgMatchesTenant(tenant, orgName) {
  if (!tenant?.orgNameMatchers || !orgName) return false;
  const n = String(orgName).toLowerCase().trim();
  return tenant.orgNameMatchers.some((m) => {
    if (n === m) return true;
    const re = new RegExp(`\\b${m.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}\\b`);
    return re.test(n);
  });
}
